
<template>
  <v-app id="onValu">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{valu.valu_code}} - {{valu.valu_oms}}   <v-btn class="primary ma-2" small @click="saveValu(valu)">Save</v-btn><br>
      <br>
      

      <v-text-field v-model="valu.valu_symbol_pdf" label="PDF symbol"></v-text-field>

    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['valu_encrid'],
  data() {
    return {
      valu: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/valu/getValu.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getValu"
          },
          getValu: {
             valu_encrid: this.valu_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.valu = res.data.getValu;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveValu(valu) { 
      this.$axios
        .post("ares/json/ares/syst/ref/valu/saveValu.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveValu"
          },
          saveValu: {
            valu: valu
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveValu.text,
              color: res.data.saveValu.color
            });
          }
        })
    }
  }  

};

</script> 
